import styles from "./RequiredAsterisk.module.scss";

export default function RequiredAsterisk() {
  return <span className={styles.required}>&nbsp;*</span>;
}
